import React from 'react';

interface ExpandableHeaderProps {
  isOpen: boolean;
  title: string;
}

export default class ExpandableHeader extends React.PureComponent<ExpandableHeaderProps> {
  render() {
    return (
      <p className="expandable-header">
        {this.props.title}
        <span className={`gik-icon-v2 ${this.props.isOpen ? 'icon-v2-chevronDown' : 'icon-v2-chevronRight'}`}></span>
      </p>
    );
  }
}
